import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import MethodChooser from "../../choosers/MethodChooser";
import ShareWithinPrivateSectorByGniGroupChart from "./ShareWithinPrivateSectorByGniGroupChart";

const ShareWithinPrivateSectorByGniGroupChartWidget = props => {
  const [methodId, setMethodId] = useState();

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId={props.dataViewerId}
      reference={props.reference}
      title={props.title}
      subtitle="Comparison by GNI Group"
      contentWidth={400}
      filters={[
        <MethodChooser
          id={props.chooserId}
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: `theme3.${props.id}`,
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      initialAbsolute={false}
      chartRef={ref}
      chartSettings={{
        method: methodId ? props.database.methods[methodId] : "All"
      }}
      downloadAbsoluteValues={true}
    >
      <ShareWithinPrivateSectorByGniGroupChart
        ref={ref}
        data={props.data}
        tooltipFormatter={props.tooltipFormatter}
      />
    </AbsoluteChartToggleFrame>
  );
};

ShareWithinPrivateSectorByGniGroupChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  dataViewerId: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  chooserId: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func,
  onChange: PropTypes.func.isRequired
};

export default ShareWithinPrivateSectorByGniGroupChartWidget;
